<template>
  <div>
    <rest-page>
      <div class="main-ct">
        <preview-content-sidebar
          @variant-change="variantKey = $event"
          @workflow-email-change="workflowEmail = $event"
          @language-change="language = $event"
          @data-change="onDataChange"
          :model="model"
        />
        <preview-content
          :model="model"
          :variant-key="variantKey"
          :workflow-email="workflowEmail"
          :language="language"
          :profile-id="profileId"
          :custom-attributes="customAttrs"
          class="preview-ct"
        />
      </div>
    </rest-page>
    <el-row class="footer">
      <el-col class="footer-ct btn-ct">
        <el-button
          :class="[
            isFramed
              ? 'nav-framed'
              : isCollapsed
              ? 'nav-collapsed'
              : 'nav-expanded'
          ]"
          plain
          type="primary"
          icon="el-icon-s-promotion"
          @click="showPreviewSendDialog"
        >
          {{ $t('CampaignForm_Preview_Send_Preview') }}
        </el-button>
        <el-button type="primary" @click="nextStep" data-qa="next-step-btn">
          {{ nextBtnLabel }}
          <i class="el-icon-arrow-right el-icon-right" />
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import PreviewContentSidebar from '@/modules/campaign-manage/components/preview/PreviewContentSidebar.vue'
import PreviewContent from '@/modules/campaign-manage/components/preview/PreviewContent.vue'
import RestPage from '@/common/components/rest/RestPage.vue'
import { EventBus } from '@/core/EventBus'
import { campaignTriggerTypes } from '@/modules/campaign-manage/enum/CampaignTriggerTypesEnum'

export default {
  name: 'StepPreview',
  components: {
    RestPage,
    PreviewContentSidebar,
    PreviewContent
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      variantKey: 'A',
      workflowEmail: {},
      language: this.model.languages_default,
      profileId: null,
      customAttrs: null,
      isCollapsed: window.localStorage.getItem('navState') === 'collapsed'
    }
  },

  mounted() {
    EventBus.$on('nav-state-change', navState => {
      this.isCollapsed = navState === 'collapsed'
    })
  },

  computed: {
    nextBtnLabel() {
      let index = 5
      if (
        this.model.trigger === campaignTriggerTypes.TRIGGER_LOCATION ||
        this.model.trigger === campaignTriggerTypes.TRIGGER_EVENT
      ) {
        index = 6
      }

      return this.$t('CampaignForm_Preview_NextButton_Title', { index: index })
    },
    isFramed() {
      return window.top !== window.self
    }
  },

  methods: {
    onDataChange($event) {
      if (typeof $event === 'string') {
        this.profileId = $event
        this.customAttrs = null
      } else {
        this.customAttrs = $event
        this.profileId = null
      }
    },
    nextStep() {
      EventBus.$emit('campaign-create-next-step')
    },
    showPreviewSendDialog() {
      EventBus.$emit('showSendPreview')
    }
  }
}
</script>
<style scoped>
.main-ct {
  display: flex;
  min-height: calc(100vh - 262px);
  width: 100%;
}

.preview-ct {
  background-color: #f8fafc;
}

.footer {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 60px;
  background: #ffffff;
  z-index: 1;
  border-top: 1px solid #e5e5e5;
  margin: 0 !important;
}

.footer-ct {
  margin-right: 20px;
  margin-bottom: 12px;
  position: absolute;
  bottom: 0;
  right: 0;
}

.btn-ct {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.nav-framed {
  margin-left: 45px;
}

.nav-collapsed {
  margin-left: 110px;
}

.nav-expanded {
  margin-left: 350px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/pages/StepPreview.vue